// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"8d6c4bda","238":"4e5d8806","479":"1b6c38b3","496":"4d03edcb","526":"9e90353e","533":"31c993f4","678":"1ab44eee","856":"92f98c1f","923":"06d678ce"}[chunkId] + ".chunk.js";
};